import * as _ from 'underscore';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quickFilter',
  pure: false
})
export class QuickFilterPipe<T> implements PipeTransform {

  /**
   * Filters the collection by the given key-value pairs.
   * Does not work on nested keys just yet.
   * @param {any[]} value
   * @param args
   * @returns {any}
   */
  public transform(value: T[], args?: any): T[] {
    return _.where(value, args);
  }

}
